import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useAppSelector } from '../app/hooks';
import {  getPageSizeArray, paginationStyles } from '../common/timeLiveFunction';

const PageSizeSelect = ({ onChange }: any) => {
    const { pageSize: pPageSize,maxMenuHeight } = useAppSelector((state) => state.globalState);
    const [pageSize, setPageSize] = useState(pPageSize); // Local state for page size
    const options = getPageSizeArray();

    useEffect(() => {
        // Set the initial page size based on user preference
        setPageSize(pPageSize);
        onChange({label: pPageSize, value:pPageSize });
    }, [pPageSize]);

    const handlePageSizeChange = (selectedOption: any) => {
        const newPageSize = parseInt(selectedOption.value);
        setPageSize(newPageSize);
        onChange(selectedOption); // Call the parent onChange handler if provided
    };

    return (
        <Select
            styles={paginationStyles}
            maxMenuHeight={maxMenuHeight}
            options={options}
            value={options.find(option => parseInt(option.value) === pageSize)}
            onChange={handlePageSizeChange}
            className='fs-7 fw-normal'
        />
    );
};

export default PageSizeSelect;
